import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

const Wrapper = styled.div`
  .modal-content {
    max-width: 24em;

    .notification {
      padding: 2em;
    }
  }
`

const AdminSuccess = props => (
  <Wrapper className={props.className}>
    <div className="modal-background" />
    <div className="modal-content">
      <div className="notification">
        <p>{props.type} Successful</p>
      </div>
    </div>
  </Wrapper>
)
export default AdminSuccess

AdminSuccess.propTypes = {
  type: PropTypes.string.isRequired,
  className: PropTypes.string.isRequired,
}



// WEBPACK FOOTER //
// /opt/build/repo/src/components/admin/AdminSuccess.js